import type { WeeklySeries, DailySeries } from '@/api/worldCup';
import { ChartCard } from '../ui/ChartCard';
import { WeeklyBars } from '../WeeklyBars';
import { DailyBars } from '../DailyBars';

/*
 * Engagement / games charts ship as EITHER `weekly_*` (iso-week bucketed) or
 * `daily_*` (calendar-day bucketed) depending on the backend region:
 *   Brazil  → weekly
 *   Spain   → daily
 *   France  → daily
 *
 * Views pass both fields in; this component picks the daily series when
 * present (newer convention) and falls back to the weekly one. If both are
 * absent it renders nothing — caller decides whether to show a placeholder.
 */
type Props = {
  weekly?: WeeklySeries;
  daily?: DailySeries;
  /** Title override. Defaults to the series' own `label`. */
  title?: string;
  /** Bar fill colour token. */
  color?: string;
};

export function SeriesBars({ weekly, daily, title, color }: Props) {
  if (daily) {
    return (
      <ChartCard title={title ?? daily.label} unit={daily.unit}>
        <DailyBars series={daily} color={color} />
      </ChartCard>
    );
  }
  if (weekly) {
    return (
      <ChartCard title={title ?? weekly.label} unit={weekly.unit}>
        <WeeklyBars series={weekly} color={color} />
      </ChartCard>
    );
  }
  return null;
}
